var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 3.33105C8.57609 3.33105 3.33301 8.57414 3.33301 14.9977C3.33301 21.4213 8.57609 26.6644 14.9997 26.6644C17.913 26.6644 20.5747 25.5778 22.6234 23.7998L23.333 24.5094V26.6644L33.333 36.6644L36.6663 33.3311L26.6663 23.3311H24.5114L23.8018 22.6214C25.5797 20.5727 26.6663 17.9111 26.6663 14.9977C26.6663 8.57414 21.4233 3.33105 14.9997 3.33105ZM14.9997 6.66439C19.6218 6.66439 23.333 10.3756 23.333 14.9977C23.333 19.6198 19.6218 23.3311 14.9997 23.3311C10.3776 23.3311 6.66634 19.6198 6.66634 14.9977C6.66634 10.3756 10.3776 6.66439 14.9997 6.66439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.25bdf3719bc5a751ec919d56c93f363c.svg";
export { ForwardRef as ReactComponent };